/* eslint-disable import/namespace */
import * as CryptoJS from 'crypto-js';
import config from 'config';

export const createHmac = (data: any): any => {
  return CryptoJS.HmacSHA256(
    JSON.stringify(data),
    config.middlewareHmacToken
  ).toString(CryptoJS.enc.Hex);
};

export const encryptDataWithAES = (data: any, key: string): any => {
  try {
    const hashedKey = CryptoJS.SHA256(key).toString(CryptoJS.enc.Hex);
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const encryptedData = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Hex.parse(hashedKey),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC
      }
    );
    return JSON.stringify({
      encryptedData: encryptedData.toString(),
      iv: iv.toString(CryptoJS.enc.Base64)
    });
  } catch (error: any) {
    throw new Error(`Encryption failed: ${error.message}`);
  }
};
